import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CreationStepContent',
  props: {
    existing: {
      type: [Object, Array],
      required: false,
      default: function _default() {
        return {};
      }
    },
    currentStep: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  methods: {
    nextStep: function nextStep(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                window.scrollTo(0, 0);
                _this.loading = true;

                if (!(_this.currentStep < 3)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return _this.$store.dispatch('series/updateNewSeries', data).then(function () {
                  _this.$emit('update:currentStep', _this.currentStep + 1);

                  _this.loading = false;
                });

              case 5:
                _context2.next = 9;
                break;

              case 7:
                _context2.next = 9;
                return _this.$store.dispatch('series/updateNewSeries', data).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var _this$existing;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!((_this$existing = _this.existing) !== null && _this$existing !== void 0 && _this$existing.id)) {
                            _context.next = 5;
                            break;
                          }

                          _context.next = 3;
                          return _this.$store.dispatch('series/update', _this.existing.id).catch(function (error) {
                            _this.loading = false;
                            console.log(error);
                          });

                        case 3:
                          _context.next = 7;
                          break;

                        case 5:
                          _context.next = 7;
                          return _this.$store.dispatch('series/create').catch(function (error) {
                            _this.loading = false;
                            console.log(error);
                          });

                        case 7:
                          _this.$emit('update:currentStep', 0);

                          _this.$router.push('/lab/series');

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    previousStep: function previousStep() {
      window.scrollTo(0, 0);

      if (!this.currentStep) {
        this.$router.push('/');
      } else {
        this.$emit('update:currentStep', this.currentStep - 1);
      }
    }
  }
};